import { useLang } from "hooks/useLang"
import { MainLayout } from "components/Layout"
import Image from "next/image"
import Form from "components/FormsPage/ContactUs/Form"
import ContactDetails from "components/FormsPage/ContactUs/ContactDetails"
import getEvents from "api/event/fetchEvents"

export async function getServerSideProps() {
    try {
        const eventResponse = await getEvents()
        const events = eventResponse?.payload || []

        return {
            props: {
                events,
            },
        }
    } catch {
        return {
            props: {
                events: [],
            },
        }
    }
}

export default function ContactUs({ events }) {
    const { t } = useLang()

    return (
        <MainLayout>
            <div className="relative overflow-hidden">
                <div className="absolute bottom-0 right-0 top-0 h-screen w-full scale-150 opacity-70 md:-right-20 md:w-1/2 md:opacity-100">
                    <Image
                        src={"/svg/v2/support_bg.png"}
                        alt="support_bg"
                        style={{ objectFit: "contain" }}
                        fill
                        priority
                    />
                </div>

                <div className="relative flex flex-col gap-10 py-32 layout md:flex-row md:py-40">
                    <div className="flex w-full flex-col">
                        <div className="flex w-full items-start gap-2 md:w-1/2">
                            <Image
                                src={"/svg/v2/sparkle.png"}
                                alt="sparkle"
                                style={{ objectFit: "contain" }}
                                height={120}
                                width={120}
                            />
                            <h1 className="mb-5 text-[56px] font-bold leading-[50px] md:mb-8 md:text-[100px] md:leading-[100px]">
                                {t("CONTACT_US_TITLE")}
                            </h1>
                        </div>

                        <div className="flex flex-col items-start md:flex-row">
                            <Form events={events} />
                            <ContactDetails />
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}
